"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultAutoAIAgentProvider = exports.autoAIAgentProviderOptions = exports.AutoAIAgentScreen = void 0;
const autoAI_1 = require("../autoAI/model/autoAI");
// Represents the screen currently displayed inside AutoAIAgentModal.
var AutoAIAgentScreen;
(function (AutoAIAgentScreen) {
    AutoAIAgentScreen["SELECTOR"] = "selector";
    AutoAIAgentScreen["CHAT"] = "chat";
})(AutoAIAgentScreen || (exports.AutoAIAgentScreen = AutoAIAgentScreen = {}));
exports.autoAIAgentProviderOptions = [
    autoAI_1.autoAIProvider.OpenAI,
    autoAI_1.autoAIProvider.DeepSeek,
    autoAI_1.autoAIProvider.Google,
];
exports.defaultAutoAIAgentProvider = autoAI_1.autoAIProvider.OpenAI;
